module.exports = __webpack_public_path__ + "static/media/blogmain.ef2d10fa.png";